import { useContext, useEffect, useRef, useState } from 'react';
import { store } from 'components/Store';
import { useContentResults } from 'components/Dashboard/ContentResultsContext';
import { CreateGroupModal } from 'components/Dashboard/Influence/CrmGroups/CreateGroupButton';
import { RemoveGroupsModal } from 'components/Dashboard/Influence/CrmGroups/RemoveGroupsModal';
import thousandCommas from 'components/Dashboard/helpers/thousandCommas';
import GroupAlertsSelect from './GroupAlertsSelect';
import { useLocation, useNavigate } from 'react-router-dom';
import getUrlParam from 'components/Dashboard/utilities/getUrlParam';
import preventLink from 'components/Dashboard/TagsList/prevenLink';

const GroupViewSubnav = () => {
  const globalState = useContext(store);
  const { state } = globalState;
  const { contentResults } = useContentResults();
  const { group } = state;
  const { CrmContacts } = contentResults;

  const searchQuery = getUrlParam('search');

  const [isOpen, setIsOpen] = useState(false);
  const [defaultView, setDefaultView] = useState('create');
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [isOpenSearch, setIsOpenSearch] = useState(!!searchQuery);
  const { type } = group ?? {};

  const searchResultsState = !!searchQuery && CrmContacts?.searchQuery === searchQuery;

  return (
    <>
      <div className='w-100  flex-grow-1'>
        <div className='w-100 overflow-auto flex-centered justify-content-between px-3 pr-lg-0 pl-lg-4 pb-lg-0'>
          {!isOpenSearch && (
            <h4
              className='mb-0 flex-centered justify-content-between  flex-grow-1 group-view-title mr-2 mr-lg-0'
              onClick={() => {
                setIsOpen(true);
              }}
            >
              <span className='hidden-lines main-title hidden-one-line'>{group ? group?.name : ''}</span>
              <span className=' d-none d-lg-flex bg-light-blue text-white rounded-circle mx-3 flex-centered justify-content-center group-view-edit-button'>
                <span className='icon-edit-pencil paragraph-p3' />
              </span>
            </h4>
          )}
          <div className={`flex-centered ${isOpenSearch ? 'flex-grow-1' : ''}`}>
            {!!group && (
              <>
                {!!CrmContacts && (
                  <>
                    <GroupViewSearch isOpenState={{ isOpen: isOpenSearch, setIsOpen: setIsOpenSearch }} />
                    <p
                      className={`nowrap-item mb-0 rounded-pill px-4 border subnav-group-type ${searchResultsState ? 'bg-light-blue-hovered' : `subnav-group-type-${type?.toLowerCase()}`}  paragraph-p2 subnav-buttons-spacing`}
                      style={{ minWidth: '300px', maxWidth: '300px' }}
                    >
                      {!searchResultsState && <span className={`group-type group-type-${type?.toLowerCase()}`} />}
                      {searchResultsState ? (
                        <>
                          <span className='font-weight-bold'>
                            {thousandCommas(CrmContacts?.totalHits)} / {thousandCommas(CrmContacts?.totalResultsNumber)}
                          </span>{' '}
                          contact{CrmContacts?.totalResultsNumber?.length === 1 ? '' : 's'} match this search
                        </>
                      ) : (
                        <>
                          {type} group with{' '}
                          {`${!!CrmContacts?.totalResultsNumber ? thousandCommas(CrmContacts?.totalResultsNumber) : 0} contact${CrmContacts?.totalHits === 1 ? '' : 's'}`}
                        </>
                      )}
                    </p>
                  </>
                )}
                {type === 'Dynamic' && <GroupAlertsSelect />}
                {type === 'Dynamic' && (
                  <button
                    className='nowrap-item d-lg-none outline-active-button px-4 general-button rounded-button ml-3 paragraph-p2 subnav-buttons-spacing'
                    onClick={() => {
                      setDefaultView('filters');
                      setIsOpen(true);
                    }}
                  >
                    Filters
                  </button>
                )}
                <button
                  className='border px-3 general-button rounded-button ml-3 paragraph-p2 subnav-buttons-spacing action-state-hover flex-centered text-left'
                  style={{ minWidth: '146px', maxWidth: '146px' }}
                  onClick={() => {
                    setIsOpen(true);
                  }}
                >
                  <span className='icon-three-dots mr-2 main-light-text' />
                  {isOpenSearch ? (
                    <span className='hidden-lines hidden-one-line w-100'>{group ? group?.name : ''}</span>
                  ) : (
                    'Group details'
                  )}
                </button>
              </>
            )}
          </div>
        </div>
      </div>
      <CreateGroupModal
        setIsOpenDelete={(val) => {
          setIsOpenDelete(val);
          setIsOpen(!val);
        }}
        maxWidth={750}
        openState={{ isOpen, setIsOpen }}
        defaultView={defaultView}
      />
      <RemoveGroupsModal openState={{ isOpen: isOpenDelete, setIsOpen: setIsOpenDelete }} groupsCount={1} />
    </>
  );
};

const GroupViewSearch = (props) => {
  const { isOpenState } = props;
  const { isOpen, setIsOpen } = isOpenState;
  const searchQuery = getUrlParam('search');

  const [value, setValue] = useState(searchQuery ?? '');

  const location = useLocation();
  const navigate = useNavigate();
  const inputSearch = useRef(null);

  useEffect(() => {
    if (isOpen) {
      inputSearch.current.focus();
    } else {
      inputSearch.current.blur();
    }
  }, [isOpen]);

  return (
    <>
      <div
        className={`mr-3 ${isOpen ? 'rounded-pill pr-2 pl-3 flex-grow-1' : 'circle-button-38 rounded-circle overflow-hidden specific-left-padding-9'}  border action-state-hover flex-centered bg-white groups-search-button `}
        onClick={() => setIsOpen(true)}
        style={{ height: isOpen ? '38px' : null }}
      >
        <button className={`general-button light-50-text`}>
          <span className={`icon-search d-inline-block-centered`} />
        </button>
        <div
          className='flex-grow-1 flex-centered justify-content-between'
          style={{ visibility: isOpen ? 'visible' : 'hidden' }}
        >
          <input
            ref={inputSearch}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            className='px-3 input-empty flex-grow-1'
            type='text'
            placeholder='Search by name, role, description or tag '
            onKeyDown={(e) => {
              if (e.keyCode === 13) {
                const value = e.target.value;
                inputSearch.current.blur();
                const searchParams = new URLSearchParams(location.search);
                searchParams.set('search', value);
                navigate({
                  search: `?${searchParams.toString()}`,
                });
              } else if (e.keyCode === 9) {
                e.preventDefault();
              }
            }}
          />
          <button
            className='general-button  light-50-text ml-2 action-state-hover circle-button-30 flex-centered justify-content-center'
            onClick={(e) => {
              preventLink(e);
              setValue('');
              const searchParams = new URLSearchParams(location.search);
              searchParams.delete('search');
              navigate({
                search: `?${searchParams.toString()}`,
              });
              setIsOpen(false);
            }}
          >
            <span className='icon-close paragraph-p5  specific-top-margin-0' />
          </button>
        </div>
      </div>
    </>
  );
};

export default GroupViewSubnav;
